import { OnboardingState } from './types';

export const WS_KEY_HIDE_BANNER = 'hideBanner';
export const WS_KEY_FLOW_SHOWN = 'flowShown';
export const WS_KEY_CURRENT_ON_BOARDING_STEP =
    'WS_KEY_CURRENT_ON_BOARDING_STEP';
export const WS_KEY_ON_BOARDING_STEP_HISTORY =
    'WS_KEY_ON_BOARDING_STEP_HISTORY';

export const ALL_ONBOARDING_STEP_LIST: OnboardingState[] = [
    'START_WORK',
    'INVITE_BANNER',
    'UPLOAD_WEB_BANNER',
    'CHECK_USERS_BANNER',
];

export const INIT_ON_BOARDING_STEP_HISTORY: OnboardingState[] = ['START_WORK'];
